import { Component, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService, HelperService } from '@app/core';
import { FilterTagsModalComponent } from '@app/shared/components/modal/filter-tags-modal/filter-tags-modal.component';
import { each } from 'lodash';

@Component({
    selector: 'app-knowledge-base',
    templateUrl: './knowledge-base.component.html',
    standalone: false
})
export class KnowledgeBaseComponent implements OnInit {

  data: any = {};
  isProcessing: Boolean = false;
  searchText: string = '';
  tags:any = '';

  constructor(
    private activeRoute: ActivatedRoute,
    private apiService: ApiService,
    private helperService: HelperService
  ) { }

  ngOnInit(): void {
    this.getKnowledgebaseArticles();
    this.setDefaultTags();
    this.tags = this.helperService.getKnowledgebaseTags();
  }

  ngAfterViewInit() {
    this.setTagAndSearch();
  }

  setDefaultTags() {
    this.data.allTags = this.helperService.getKnowledgebaseTags();
    this.setActiveTags([this.data.allTags[0]]);
  }

  setActiveTags(tags: Array<string>) {
    this.data.activeTags = tags;
  }

  setSearchText(value){
    this.searchText = value;
  }

  setTagAndSearch() {
    this.activeRoute.queryParams.subscribe(params => {
      let tag = (params['tag']) ? params['tag'] : this.data.activeTags;
      let search = (params['search']) ? params['search'] : this.searchText;

      if(tag && typeof tag == "object" && tag.length > 0){
        this.data.activeTags = tag.map((t: string) => t.split('-').join(' ').replace('and', '&'));
      }else{
        this.data.activeTags = tag.split('-').join(' ').replace('and', '&');
      }
      this.searchText = search.split('-').join(' ').replace('and', '&');
    });
  }

  getKnowledgebaseArticles() {
    this.isProcessing = true;

    this.apiService.get('knowledge-base').subscribe((knowledgebaseArticles: any) => {

      // Adding a new key with the name : 'name'. Becuase to make it work with search title
      knowledgebaseArticles = each(knowledgebaseArticles, function (knowledgebaseArticle: any, key: any) {
        knowledgebaseArticles[key].name = knowledgebaseArticle.title;
      });

      this.data.knowledgebaseArticles = knowledgebaseArticles;
      this.isProcessing = false;
    });
  }

  redirectToKBArticle(slug: string) {
    let search = (this.searchText).split(" ").join("-").replace('&', 'and');
    let tag = this.data.activeTags.map((t: string) => t.split(" ").join("-").replace('&', 'and'));
    this.helperService.navigateToUrl('/knowledge-base/' + slug + '?tag=' + tag + '&search=' + search);
  }

  openTagFilterModal() {

    let modalRef = this.helperService.openModal(FilterTagsModalComponent, {
      tags: this.helperService.getKnowledgebaseTags(),
      heading: 'Search knowledge base by tags',
      preSelectedTags:this.data.activeTags
    });

    modalRef.output().subscribe(selectedTags => this.setActiveTags(selectedTags));
  }

  back() {
    this.helperService.jumpToPreviousPage();
  }
}
